import { BehaviorSubject, Observable } from 'rxjs';
import { IAmendOrderService } from './amend-order.interface';
import { injectable } from 'inversify';
import { IPendingOrderReport } from '../../interfaces';

@injectable()
export class AmendOrderService implements IAmendOrderService {
    // NOTE: A BehaviorSubject is mandatory here because we need to keep
    // the state of what is going on. A late subscriber should still be
    // informed of the state of the amending.
    private readonly subject = new BehaviorSubject<IPendingOrderReport>(null);

    addOrder(newOrder: IPendingOrderReport): void {
        this.subject.next(newOrder);
    }

    asObservable(): Observable<IPendingOrderReport> {
        return this.subject.asObservable();
    }
}
